import {LoadingButton} from '@mui/lab';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
} from '@mui/material';
import {useSnackbar} from 'notistack';
import {useState} from 'react';

import API, {getMessagesFromApiError} from '../../api/axios';
import {apiBaseUrl} from '../../api/urls';
import {AlarmModuleNode} from '../../interfaces/AlarmModuleNode';
import {CloseSnackbarAction} from '../common/CloseSnackbarButton';
import SnackbarMessages from '../common/SnackbarMessages';

interface Props extends Omit<DialogProps, 'onClose'> {
  item: AlarmModuleNode;
  onSubmitted?: (item: AlarmModuleNode) => void;
  onClose?: () => void;
}

const AlarmItemActivationModal = ({
  item,
  onSubmitted,
  onClose,
  ...props
}: Props) => {
  const {enqueueSnackbar} = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const actionName = item.status === 'active' ? 'DeActivate' : 'Activate';

  const submit = async (pk: number) => {
    setIsSubmitting(true);
    try {
      const resp = await API.patch<AlarmModuleNode>(
        `${apiBaseUrl}/alarm-module/${pk}`,
        {
          status: actionName === 'Activate' ? 'active' : 'inactive',
        }
      );
      const message = `Alarm successfully ${
        actionName === 'Activate' ? 'activated' : 'deactivated'
      }`;
      enqueueSnackbar(message, {
        variant: 'success',
        action: CloseSnackbarAction,
      });
      onSubmitted?.(resp?.data);
      onClose?.();
    } catch (error: any) {
      const messages = getMessagesFromApiError(error, "STRA_59e45adf");
      enqueueSnackbar(<SnackbarMessages messages={messages} />, {
        variant: 'error',
        action: CloseSnackbarAction,
      });
    }
    setIsSubmitting(false);
  };

  return (
    <Dialog {...props} onClose={onClose}>
      <DialogTitle>{actionName} Alarm</DialogTitle>

      <DialogContent>
        <DialogContentText>
          Are you sure you want to {actionName} this alarm?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose?.()}>Cancel</Button>
        <LoadingButton
          variant="contained"
          loading={isSubmitting}
          autoFocus
          onClick={() => submit(item.id)}
          color={actionName === 'Activate' ? 'success' : 'warning'}
        >
          {actionName}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default AlarmItemActivationModal;
